<template lang="pug">
  .vendor-item
    .vendor-item__header
      .left(@click="view(itemData)")
        .vendor-item__header__img
          img(
            v-if="itemData.width",
            :src="itemData.download_url"
            :class="{ widthFixed: itemData.width/itemData.height >= 1, heightFixed: itemData.width/itemData.height < 1 }",
          )
        .vendor-item__header__text
          div
            span.title {{ itemData.vendor_name_ch }} {{ itemData.vendor_name }}
            i(v-if="itemData.is_storage").iconfont.icon-r
          div
            span {{ $t('广告主评分') }}:
            el-rate(
              :value="Number(itemData.overall.toFixed(1))"
              disabled
              text-color="#f7a04c"
              score-template="{value}"
            )
            span {{ Number(itemData.overall.toFixed(1)) }}
      .right
        contact-icon(:basicData="contactIconData")
        el-dropdown(
          v-if="isPurchase"
          @command="handleCommand"
          trigger="click"
        )
          i.iconfont.icon-more(style="margin-left: 16px")
          el-dropdown-menu(
            slot="dropdown"
          )
            el-dropdown-item(
              command="handleEdit"
            ) {{ $t('编辑') }}
    .vendor-item__content
      .vendor-item__content__category
        span {{ $t('服务范围') }}
        div(v-for="c in itemData.category")
          span {{ c.category_name }}
          div
            template(v-for="s,i in c.children")
              span {{ s.scope_name }}
              span.slash(
                v-if="i !== (c.children.length - 1)"
              ) /
      .right
        .vendor-item__content__client
          span {{ $t('行业和客户') }}
          div(v-for="i in itemData.vendor_experience")
            span {{ $t(i.industry_name) }}
            div
              template(v-for="c,index in i.client_name.split(',')")
                span {{ c }}
                span.slash(
                  v-if="index !== (i.client_name.split(',').length - 1)"
                ) /
        .vendor-item__content__info
          div
            i.iconfont.icon-weizhi
            span {{ itemData.city ? $t(itemData.city) : "—"}}
          div
            i.iconfont.icon-renshu
            span {{ itemData.company_size ? $t(COMPANY_SIZE[itemData.company_size]) : "—" }}
          div
            i.iconfont.icon-shijian
            span {{ itemData.establish_time ? itemData.establish_time + $t("年") : "—" }}
          div
            i.iconfont.icon-biaoqian1
            span {{ itemData.company_type === 1 ? $t("非上市公司") : $t("上市公司") }}
</template>

<script>
import ContactIcon from '@/components/ContactIcon'

const COMPANY_SIZE = {
  1: '少于30人',
  2: '30-50人',
  3: '50-100人',
  4: '100-300人',
  5: '大于300人'
}

export default {
  components: {
    ContactIcon
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      COMPANY_SIZE
    }
  },
  computed: {
    isPurchase () {
      return this.$store.state.common.user.struct_group_type === '20'
    },
    permissions () {
      return this.$store.getters.user.permissions
    },
    contactIconData () {
      return {
        weibo_qr_code_url: this.itemData.weibo_qr_code_url,
        wechat_qr_code_url: this.itemData.wechat_qr_code_url,
        website_url: this.itemData.website_url
      }
    }
  },
  methods: {
    view (item) {
      this.$store.commit('vendor/setId', item.vendor_id)
      this.$store.commit('vendor/setName', item.vendor_name_ch)
      this.$router.push('/vendor/info/basic-info')
    },
    handleCommand (commond) {
      switch (commond) {
        case 'handleEdit':
          this.$router.push('/vendor-management/new-vendor?id=' + this.itemData.vendor_id)
      }
    }
  }
}
</script>

<style lang="stylus">
.vendor-item
  display flex
  flex-direction column
  border-bottom 1px solid #edf2fa
  padding 24px 24px 16px 24px
  background-color #fff
  margin-bottom 24px

.vendor-item__header
  align-items center
  display flex
  justify-content space-between
  padding-bottom 14px
  border-bottom 2px solid #f6f7fb
  .right
    display flex
    align-items center
    .el-dropdown
      cursor pointer
      .icon-more
        color #bfbfbf
        &:hover
          color #8C8C8C
  .left
    cursor pointer
    display flex
    .vendor-item__header__text
      display flex
      flex-direction column
      justify-content space-between
      > div:nth-child(1)
        span:nth-child(1)
          font-size 22px
          color #262626
          margin-right 16px
        i
          color $main
          font-size 20px
      > div:nth-child(2)
        display flex
        align-items center
        > span:nth-child(1)
          color #8c8c8c
          margin-right 10px
        > span:nth-child(3)
          color #f7a04c
      .el-rate__item
        cursor pointer !important
.vendor-item__header__img
  height: 58px
  width: 58px
  border: 1px solid #e8e8e8
  margin-right 23px
  display flex
  justify-content center
  align-items center
  > .widthFixed
    width 58px
  > .heightFixed
    height 58px

.vendor-item__content
  padding-top 16px
  display flex
  justify-content space-between
  .right
    display flex

.vendor-item__content__category
  > span
    font-weight 600
  span
    display inline-block
    margin-bottom 8px
    height 18px
    line-height 18px
  > div
    margin-bottom 12px
    > div
      line-height 20px
    > span
      font-size 12px
      color #8c8c8c
  .slash
    margin 0 15px
    color #bfbfbf

.vendor-item__content__client
  padding-left 24px
  width 330px
  border-left 1px solid #f0f2f5
  > span
    font-weight 600
  span
    display inline-block
    margin-bottom 12px
    margin-bottom 8px
    height 18px
    line-height 18px
  > div
    margin-bottom 12px
    > span
      font-size 12px
      color #8c8c8c
    > div
      line-height 20px
  .slash
    margin 0 15px
    color #bfbfbf

.vendor-item__content__info
  display flex
  flex-direction column
  justify-content center
  padding-left 24px
  width 180px
  border-left 1px solid #f0f2f5
  > div
    line-height 20px
    margin-bottom 16px
    i
      font-size 12px
      margin-right 16px
</style>
